<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import TemplatesPicker from './TemplatesPicker.vue';
import WhatsAppTemplateReply from './WhatsAppTemplateReply.vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  inboxId: {
    type: Number,
    default: undefined,
  },
  sending: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['onSend', 'cancel', 'update:show']);

const { t } = useI18n();
const selectedWaTemplate = ref(null);

const localShow = computed({
  get() {
    return props.show;
  },
  set(value) {
    if (!value && props.sending) return;
    emit('update:show', value);
  },
});

const modalHeaderContent = computed(() => {
  return selectedWaTemplate.value
    ? t('WHATSAPP_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
        templateName: selectedWaTemplate.value.name,
      })
    : t('WHATSAPP_TEMPLATES.MODAL.SUBTITLE');
});

const pickTemplate = template => {
  selectedWaTemplate.value = template;
};

const onResetTemplate = () => {
  if (props.sending) return;
  selectedWaTemplate.value = null;
};

const onSendMessage = message => {
  if (props.sending) return;
  emit('onSend', message);
};

const onClose = () => {
  if (props.sending) return;
  emit('cancel');
};

watch(
  () => props.show,
  visible => {
    if (!visible) selectedWaTemplate.value = null;
  }
);

watch(
  () => props.inboxId,
  () => {
    selectedWaTemplate.value = null;
  }
);

defineExpose({
  selectedWaTemplate,
  pickTemplate,
  onResetTemplate,
  onClose,
});
</script>

<template>
  <woot-modal
    v-model:show="localShow"
    :on-close="onClose"
    :close-on-backdrop-click="!sending"
    :show-close-button="!sending"
    size="!w-[56rem] !max-w-[calc(100vw-2rem)]"
  >
    <woot-modal-header
      :header-title="$t('WHATSAPP_TEMPLATES.MODAL.TITLE')"
      :header-content="modalHeaderContent"
    />
    <div
      class="flex min-h-0 max-h-[min(70vh,40rem)] flex-col overflow-hidden px-6 py-5"
    >
      <div class="min-h-0 min-w-0 flex-1 overflow-y-auto">
        <TemplatesPicker
          v-if="!selectedWaTemplate"
          :inbox-id="inboxId"
          @on-select="pickTemplate"
        />
        <WhatsAppTemplateReply
          v-else
          :template="selectedWaTemplate"
          :sending="sending"
          @reset-template="onResetTemplate"
          @send-message="onSendMessage"
        />
      </div>
    </div>
  </woot-modal>
</template>
